import { fetcher } from '@commenda/utils';

export type TBulkSendMessageSender = 'ASSIGNED_AGENT' | 'REQUESTING_USER';

export type BulkSendMessageParams = {
  serviceRequestIds: string[];
  message: string;
  sender?: TBulkSendMessageSender;
};

/** Per-service-request result from task metadata, used for the failure table */
export type BulkSendMessageResultItem = {
  serviceRequestId: string;
  success: boolean;
  error?: string;
};

export type BulkSendMessageResponse = {
  job: { id: string };
};

type BulkSendMessageResult = {
  success: boolean;
  data?: BulkSendMessageResponse;
  error?: string;
  statusCode?: number;
};

export async function bulkSendMessage({
  serviceRequestIds,
  message,
  sender,
}: BulkSendMessageParams): Promise<BulkSendMessageResult> {
  try {
    const response = await fetcher('chatRoom/message/bulk', {
      method: 'POST',
      body: { serviceRequestIds, message, sender },
    });

    if (!response.ok) {
      const responseData = await response.json();
      return {
        success: false,
        error: responseData?.message || 'Failed to send bulk message',
        statusCode: response.status,
      };
    }

    const responseData: BulkSendMessageResponse = await response.json();
    return {
      success: true,
      data: responseData,
    };
  } catch (error) {
    const errorMessage =
      error instanceof Error
        ? error.message
        : 'Failed to send bulk message';
    return {
      success: false,
      error: errorMessage,
      statusCode: 500,
    };
  }
}
